import React from 'react';
import { Details } from './details';

/**
 * Represents a small (to embbed) red error alert message with description facilities
 */

export function GotError() {
    return (
        <div className="w3-center w3-padding-32">
            <h5>&#10060;&nbsp; Unfortunately, an error occurred when retrieving the data.</h5>
            <Details />
        </div>
    );
}
